import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './AdditionalInterestComponent.metadata.json5';
import './AdditionalInterestComponent';

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

const getDisplayName = (items, index, property) => {
    return !_.isObject(items.policyAdditionalInterest.displayName) ? items.policyAdditionalInterest.displayName : null;
};

export function AdditionalInterestComponent({ data }) {
     const overrides = {
        additionalInterestTable: {
            data: data
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCell,
            getDisplayName
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

AdditionalInterestComponent.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

AdditionalInterestComponent.defaultProps = {
    data: []
};


export default AdditionalInterestComponent;
